module.exports = __webpack_public_path__ + "static/img/gongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/gongan.png
// module id = hipX
// module chunks = 8